import { render, staticRenderFns } from "./sgs.vue?vue&type=template&id=2ad8c456&scoped=true&"
import script from "./sgs.vue?vue&type=script&lang=ts&"
export * from "./sgs.vue?vue&type=script&lang=ts&"
import style0 from "./sgs.vue?vue&type=style&index=0&id=2ad8c456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad8c456",
  null
  
)

export default component.exports